function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1_1746)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15 3.14429H3.4L4.7 1.84429C5.1 1.44429 5.1 0.844287 4.7 0.444287C4.3 0.0442871 3.7 0.0442871 3.3 0.444287L0.3 3.44429C0.2 3.44429 0.1 3.54429 0.1 3.74429V3.84429C0.1 3.94429 0.1 4.04429 0.1 4.04429C0 4.04429 0 4.14429 0 4.14429C0 4.24429 0 4.34429 0.1 4.44429C0.1 4.54429 0.2 4.64429 0.3 4.74429L3.3 7.74429C3.5 7.94429 3.7 8.04429 4 8.04429C4.3 8.04429 4.5 7.94429 4.7 7.74429C5.1 7.34429 5.1 6.74429 4.7 6.34429L3.4 5.14429H15C15.6 5.14429 16 4.74429 16 4.14429C16 3.54429 15.6 3.14429 15 3.14429Z",
  fill: "#860935"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1_1746"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 7.9,
  fill: "white",
  transform: "translate(0 0.144287)"
})));

function SvgArrowBack({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE2IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xXzE3NDYpIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNSAzLjE0NDI5SDMuNEw0LjcgMS44NDQyOUM1LjEgMS40NDQyOSA1LjEgMC44NDQyODcgNC43IDAuNDQ0Mjg3QzQuMyAwLjA0NDI4NzEgMy43IDAuMDQ0Mjg3MSAzLjMgMC40NDQyODdMMC4zIDMuNDQ0MjlDMC4yIDMuNDQ0MjkgMC4xIDMuNTQ0MjkgMC4xIDMuNzQ0MjlWMy44NDQyOUMwLjEgMy45NDQyOSAwLjEgNC4wNDQyOSAwLjEgNC4wNDQyOUMwIDQuMDQ0MjkgMCA0LjE0NDI5IDAgNC4xNDQyOUMwIDQuMjQ0MjkgMCA0LjM0NDI5IDAuMSA0LjQ0NDI5QzAuMSA0LjU0NDI5IDAuMiA0LjY0NDI5IDAuMyA0Ljc0NDI5TDMuMyA3Ljc0NDI5QzMuNSA3Ljk0NDI5IDMuNyA4LjA0NDI5IDQgOC4wNDQyOUM0LjMgOC4wNDQyOSA0LjUgNy45NDQyOSA0LjcgNy43NDQyOUM1LjEgNy4zNDQyOSA1LjEgNi43NDQyOSA0LjcgNi4zNDQyOUwzLjQgNS4xNDQyOUgxNUMxNS42IDUuMTQ0MjkgMTYgNC43NDQyOSAxNiA0LjE0NDI5QzE2IDMuNTQ0MjkgMTUuNiAzLjE0NDI5IDE1IDMuMTQ0MjlaIiBmaWxsPSIjODYwOTM1Ii8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMV8xNzQ2Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjcuOSIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC4xNDQyODcpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgArrowBack as ReactComponent };